import script from "./PhoneInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhoneInput.vue?vue&type=script&lang=ts&setup=true"

import "./PhoneInput.vue?vue&type=style&index=0&id=3b623157&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b623157"]])

export default __exports__